// extracted by mini-css-extract-plugin
export default {"Link":"TransferredEvent-module__Link__ElTLuzS"};